import { render } from "./DeviceTypeCreateComponent.vue?vue&type=template&id=688ed1e9"
import script from "./DeviceTypeCreateComponent.vue?vue&type=script&lang=js"
export * from "./DeviceTypeCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__